module.exports = __webpack_public_path__ + "assets/atlanta-sales-recruiting-agency-1.fe085dbf.png";